// a minimial single-layer implementation
// of virtual-validation patching,
// based on Vue's snabbdom clone

/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
function isUndef(v) {
  return v === null || v === undefined;
}

function isDef(v) {
  return v !== null && v !== undefined;
}

function sameSval(oldSval, sval) {
  return sval.tag === oldSval.tag && sval.key === oldSval.key;
}

function createVm(sval) {
  const Vm = sval.tag;
  sval.vm = new Vm({ data: sval.args });
}

function updateSval(sval) {
  const keys = Object.keys(sval.args);
  for (let i = 0; i < keys.length; i++) {
    keys.forEach((k) => {
      sval.vm[k] = sval.args[k];
    });
  }
}

function createKeyToOldIdx(children, beginIdx, endIdx) {
  let i; let
    key;
  const map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) map[key] = i;
  }
  return map;
}

function addSvals(svals, startIdx, endIdx) {
  for (; startIdx <= endIdx; ++startIdx) {
    createVm(svals[startIdx]);
  }
}

function removeSvals(svals, startIdx, endIdx) {
  for (; startIdx <= endIdx; ++startIdx) {
    const ch = svals[startIdx];
    if (isDef(ch)) {
      ch.vm.$destroy();
      ch.vm = null;
    }
  }
}

function patchSval(oldSval, sval) {
  if (oldSval === sval) {
    return;
  }
  sval.vm = oldSval.vm;
  updateSval(sval);
}

function updateChildren(oldCh, newCh) {
  let oldStartIdx = 0;
  let newStartIdx = 0;
  let oldEndIdx = oldCh.length - 1;
  let oldStartSval = oldCh[0];
  let oldEndSval = oldCh[oldEndIdx];
  let newEndIdx = newCh.length - 1;
  let newStartSval = newCh[0];
  let newEndSval = newCh[newEndIdx];
  let oldKeyToIdx; let idxInOld; let
    elmToMove;

  while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
    if (isUndef(oldStartSval)) {
      oldStartSval = oldCh[++oldStartIdx]; // Sval has been moved left
    } else if (isUndef(oldEndSval)) {
      oldEndSval = oldCh[--oldEndIdx];
    } else if (sameSval(oldStartSval, newStartSval)) {
      patchSval(oldStartSval, newStartSval);
      oldStartSval = oldCh[++oldStartIdx];
      newStartSval = newCh[++newStartIdx];
    } else if (sameSval(oldEndSval, newEndSval)) {
      patchSval(oldEndSval, newEndSval);
      oldEndSval = oldCh[--oldEndIdx];
      newEndSval = newCh[--newEndIdx];
    } else if (sameSval(oldStartSval, newEndSval)) {
      // Sval moved right
      patchSval(oldStartSval, newEndSval);
      oldStartSval = oldCh[++oldStartIdx];
      newEndSval = newCh[--newEndIdx];
    } else if (sameSval(oldEndSval, newStartSval)) {
      // Sval moved left
      patchSval(oldEndSval, newStartSval);
      oldEndSval = oldCh[--oldEndIdx];
      newStartSval = newCh[++newStartIdx];
    } else {
      if (isUndef(oldKeyToIdx)) oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
      idxInOld = isDef(newStartSval.key)
        ? oldKeyToIdx[newStartSval.key]
        : null;
      if (isUndef(idxInOld)) {
        // New element
        createVm(newStartSval);
        newStartSval = newCh[++newStartIdx];
      } else {
        elmToMove = oldCh[idxInOld];
        if (sameSval(elmToMove, newStartSval)) {
          patchSval(elmToMove, newStartSval);
          oldCh[idxInOld] = undefined;
          newStartSval = newCh[++newStartIdx];
        } else {
          // same key but different element. treat as new element
          createVm(newStartSval);
          newStartSval = newCh[++newStartIdx];
        }
      }
    }
  }
  if (oldStartIdx > oldEndIdx) {
    addSvals(newCh, newStartIdx, newEndIdx);
  } else if (newStartIdx > newEndIdx) {
    removeSvals(oldCh, oldStartIdx, oldEndIdx);
  }
}

export function patchChildren(oldCh, ch) {
  if (isDef(oldCh) && isDef(ch)) {
    if (oldCh !== ch) updateChildren(oldCh, ch);
  } else if (isDef(ch)) {
    addSvals(ch, 0, ch.length - 1);
  } else if (isDef(oldCh)) {
    removeSvals(oldCh, 0, oldCh.length - 1);
  }
}

export function h(tag, key, args) {
  return { tag, key, args };
}

/* eslint-enable no-param-reassign */
/* eslint-enable no-plusplus */
